export const keywords =
  'itr filing for esop, itr filing for stock options trading, esop tax filing in india, itr filing for rsu, itr filing for restricted stock units, rsu tax filing in india, cleartax itr filing for esop, cleartax itr filing for rsu';

export const canonical = 'https://cleartax.in/itr-filing-for-esop-and-rsu';

export const description =
  'ITR Filing for ESOPs & RSUs: File Income Tax Return for gains from employee stock options and restricted stock units (RSUs) in India with ClearTax.';

export const pageTitle =
  'ITR Filing for ESOPs (Stock options) & RSUs (Restricted stock units) | ClearTax';
